import './scss/custom.scss';

import Vue from 'vue'
import App from './App.vue'

import VueI18n from 'vue-i18n'
import { languages } from './i18n/index.js'
import { defaultLocale } from './i18n/index.js'

import VueRouter from 'vue-router'
import router from './router'

import { BootstrapVue, BIcon, BIconWifi, BIconLock, BIconUnlock } from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(BootstrapVue);

Vue.component('BIcon', BIcon)
Vue.component('BIconWifi', BIconWifi)
Vue.component('BIconLock', BIconLock)
Vue.component('BIconUnlock', BIconUnlock)

const messages = Object.assign(languages)

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'de',
  messages,
})


new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
